if (!customElements.get('ec-pdp-bundle')) {
  customElements.define(
    'ec-pdp-bundle',
    class EcPdpBundle extends HTMLElement {
      constructor() {
        super();
        this.summaryTotal = this.querySelector('.ec-pdp-bundle__summary-total');
        this.summaryInstallments = this.querySelector('.ec-pdp-bundle__summary-installments');
        this.summaryText = this.querySelector('.ec-pdp-bundle__summary-text');
        this.addBtn = this.querySelector('.ec-pdp-bundle__btn');
        this.currentPrice = parseInt(this.dataset.currentPrice || '0', 10);
        this.currentVariantId = this.dataset.currentVariantId || '';
      }

      connectedCallback() {
        this.updateTotal();
        this.bindCheckboxes();
        this.bindAddButton();
        this.bindRefreshButtons();
        this.relocateStockBadges();
        this.observeRecommendations();
      }

      relocateStockBadges() {
        this.querySelectorAll('.ec-pdp-bundle__card--rec').forEach((card) => {
          const wrapper = card.querySelector('.ec-pdp-bundle__checkbox-wrapper');
          const badge = card.querySelector('.card__inner .card__badge:not(.card__badge--information)');
          if (!wrapper || !badge || badge.parentElement === wrapper) return;
          wrapper.appendChild(badge);
        });
      }

      bindRefreshButtons() {
        this.addEventListener('click', (e) => {
          const refreshBtn = e.target.closest('.ec-pdp-bundle__refresh');
          if (!refreshBtn) return;
          e.preventDefault();
          const clickedCard = refreshBtn.closest('.ec-pdp-bundle__card--rec');
          if (clickedCard) {
            this.reloadSingleCard(clickedCard);
          } else {
            this.reloadRecommendations();
          }
        });
      }

      reloadSingleCard(clickedCard) {
        const recommendations = this.querySelector('product-recommendations');
        if (!recommendations?.dataset?.url) return;
        const otherCards = recommendations.querySelectorAll('.ec-pdp-bundle__card--rec');
        const excludeIds = Array.from(otherCards).map((c) => c.dataset.productId || '').filter(Boolean);
        const baseUrl = recommendations.dataset.url.replace('limit=2', 'limit=3');
        const url = `${baseUrl}&product_id=${recommendations.dataset.productId}&section_id=${recommendations.dataset.sectionId}`;
        clickedCard.style.opacity = '0.5';
        clickedCard.style.pointerEvents = 'none';
        fetch(url)
          .then((r) => r.text())
          .then((html) => {
            const div = document.createElement('div');
            div.innerHTML = html;
            const content = div.querySelector('product-recommendations');
            const cards = content?.querySelectorAll?.('.ec-pdp-bundle__card--rec');
            const newCard = cards && Array.from(cards).find((c) => !excludeIds.includes(c.dataset.productId || ''));
            if (newCard) {
              clickedCard.outerHTML = newCard.outerHTML;
              this.bindCheckboxes();
              this.updateTotal();
            }
          })
          .catch((e) => console.error(e))
          .finally(() => {
            clickedCard.style.opacity = '';
            clickedCard.style.pointerEvents = '';
          });
      }

      reloadRecommendations() {
        const recommendations = this.querySelector('product-recommendations');
        if (!recommendations?.dataset?.url) return;
        const url = `${recommendations.dataset.url}&product_id=${recommendations.dataset.productId}&section_id=${recommendations.dataset.sectionId}`;
        recommendations.innerHTML = '<div class="ec-pdp-bundle__loading"><span class="loading__spinner"></span><span>' + (window.ecPdpBundleStrings?.loading || 'Carregando...') + '</span></div>';
        fetch(url)
          .then((r) => r.text())
          .then((html) => {
            const div = document.createElement('div');
            div.innerHTML = html;
            const content = div.querySelector('product-recommendations');
            if (content?.innerHTML?.trim()) {
              recommendations.innerHTML = content.innerHTML;
            }
            this.bindCheckboxes();
            this.updateTotal();
          })
          .catch((e) => console.error(e));
      }

      observeRecommendations() {
        const recommendations = this.querySelector('product-recommendations');
        if (!recommendations) return;
        this.syncRecommendationsWidth(recommendations);
        const observer = new MutationObserver(() => {
          this.bindCheckboxes();
          this.updateTotal();
          this.syncRecommendationsWidth(recommendations);
          this.relocateStockBadges();
        });
        observer.observe(recommendations, { childList: true, subtree: true });
      }

      syncRecommendationsWidth(recommendations) {
        const count = recommendations.querySelectorAll('.ec-pdp-bundle__card--rec').length;
        recommendations.style.flexGrow = count > 0 ? count : '';
      }

      bindCheckboxes() {
        this.querySelectorAll('.ec-pdp-bundle__checkbox:not([disabled])').forEach((cb) => {
          cb.removeEventListener('change', this.handleCheckboxChange);
          cb.addEventListener('change', this.handleCheckboxChange.bind(this));
        });
      }

      handleCheckboxChange() {
        this.updateTotal();
      }

      getSelectedItems() {
        const items = [];
        const currentCard = this.querySelector('.ec-pdp-bundle__card--current');
        if (currentCard) {
          const variantId = currentCard.dataset.variantId;
          const price = parseInt(currentCard.dataset.price || '0', 10);
          if (variantId) items.push({ variantId, price });
        }
        this.querySelectorAll('.ec-pdp-bundle__card--rec .ec-pdp-bundle__checkbox:checked').forEach((cb) => {
          const card = cb.closest('.ec-pdp-bundle__card');
          if (card) {
            const variantId = card.dataset.variantId;
            const price = parseInt(card.dataset.price || '0', 10);
            if (variantId) items.push({ variantId, price });
          }
        });
        return items;
      }

      updateTotal() {
        const items = this.getSelectedItems();
        const total = items.reduce((sum, i) => sum + i.price, 0);
        const count = items.length;

        if (this.summaryTotal) {
          this.summaryTotal.textContent = this.formatMoney(total);
          this.summaryTotal.dataset.total = total;
        }
        if (this.summaryText && window.ecPdpBundleStrings) {
          const key = count === 1 ? 'summary_text_one' : 'summary_text_other';
          let text = (window.ecPdpBundleStrings[key] || window.ecPdpBundleStrings.summary_text || '')
            .replace(/\{\{\s*count\s*\}\}/g, `<strong>${count}</strong>`)
            .replace(/\bproducts\b/g, '<strong>products</strong>')
            .replace(/\bproduct\b/g, '<strong>product</strong>')
            .replace(/\bprodutos\b/g, '<strong>produtos</strong>')
            .replace(/\bproduto\b/g, '<strong>produto</strong>');
          this.summaryText.innerHTML = text;
        }
        if (this.summaryInstallments && total > 0) {
          this.updateInstallments(total);
        }
        if (this.addBtn) {
          this.addBtn.disabled = count === 0 || total === 0;
        }
      }

      formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(cents);
        }
        return (cents / 100).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
      }

      updateInstallments(total) {
        const maxInstallments = 12;
        const minValue = 500;
        let installments = 0;
        let value = 0;
        for (let i = 1; i <= maxInstallments; i++) {
          const testValue = Math.floor(total / i);
          if (testValue >= minValue) {
            installments = i;
            value = testValue;
          } else break;
        }
        if (installments > 1) {
          const template = window.ecPdpBundleStrings?.installments || 'Até {{ count }}x de {{ value }} sem juros';
          const valueFormatted = this.formatMoney(value);
          const html = template
            .replace(/\{\{\s*count\s*\}\}/g, installments)
            .replace(/\{\{\s*value\s*\}\}/g, `<strong>${valueFormatted}</strong>`);
          this.summaryInstallments.innerHTML = html;
          this.summaryInstallments.hidden = false;
        } else {
          this.summaryInstallments.hidden = true;
        }
      }

      bindAddButton() {
        if (!this.addBtn) return;
        this.addBtn.addEventListener('click', this.handleAddToCart.bind(this));
      }

      handleAddToCart(evt) {
        evt.preventDefault();
        if (this.addBtn.disabled) return;

        const items = this.getSelectedItems();
        if (items.length === 0) return;

        const cartItems = items.map((i) => ({ id: parseInt(i.variantId, 10), quantity: 1 }));
        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');
        const useDrawerForMulti = items.length > 1 && cartDrawer;
        const cart = useDrawerForMulti ? cartDrawer : (cartNotification || cartDrawer);
        const sections = cart?.getSectionsToRender?.()?.map((s) => s.id) || [];
        const body = {
          items: cartItems,
          sections: sections.join(','),
          sections_url: window.location.pathname,
        };

        const url = (window.routes?.cart_add_url || '/cart/add').replace('/cart/add', '/cart/add.js');
        this.addBtn.setAttribute('aria-disabled', true);
        this.addBtn.classList.add('loading');
        const spinner = this.addBtn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status && data.message) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'ec-pdp-bundle',
                  message: data.message,
                });
              }
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'ec-pdp-bundle',
                cartData: data,
              });
            }
            if (cart && typeof cart.renderContents === 'function') {
              if (cart === cartNotification) {
                data.key = data.items?.[data.items.length - 1]?.key || data.key;
                if (!data.key) return;
              }
              try {
                cart.setActiveElement?.(document.activeElement);
                cart.renderContents(data);
              } catch (e) {
                console.error('ec-pdp-bundle renderContents:', e);
              }
            }
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.addBtn.removeAttribute('aria-disabled');
            this.addBtn.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
